import React, { useRef } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useThemeMode } from '../../contexts/ThemeModeProvider';
import { usePortalTokens } from '../../styles/usePortalTokens';

const PortalColorModeToggle = () => {
  const { isDarkMode, toggleMode } = useThemeMode();
  const portal = usePortalTokens();
  const buttonRef = useRef(null);
  const label = isDarkMode ? 'Switch to light mode' : 'Switch to dark mode';

  const handleClick = () => {
    const node = buttonRef.current;
    if (!node) {
      toggleMode();
      return;
    }

    const rect = node.getBoundingClientRect();
    toggleMode({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    });
  };

  return (
    <Tooltip title={label}>
      <IconButton
        ref={buttonRef}
        onClick={handleClick}
        aria-label={label}
        sx={{ p: 0.5, color: portal.textMuted }}
      >
        {isDarkMode ? (
          <LightModeOutlinedIcon fontSize="small" />
        ) : (
          <DarkModeOutlinedIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default PortalColorModeToggle;
